import { ArrowRight } from "lucide-react";

export const FinalCTA = ({ onContact }) => {
  return (
    <section className="mac-section" id="final-cta" data-testid="final-cta-section">
      <div className="mac-container" style={{ position: "relative", zIndex: 1, textAlign: "center" }}>
        <div className="mac-cta-panel" style={{ position: "relative", width: "100%" }}>
          <div className="cta-glow" />

          <div style={{ position: "relative", zIndex: 1 }}>
            <h2
              className="mac-display"
              data-testid="final-cta-headline"
              style={{ fontSize: "clamp(32px, 4.4vw, 54px)", marginTop: 8 }}
            >
              Flawless execution<br />across every door.
            </h2>

            <p
              className="mac-body"
              style={{ margin: "28px auto 0", maxWidth: 820, fontSize: 16 }}
            >
              Challenge us with your toughest display launch, compliance issue, or audit gap.
            </p>

            <p
              className="mac-body"
              style={{ margin: "16px auto 0", maxWidth: 820, fontSize: 16 }}
            >
              We'll show you exactly how The Macaron AI solves it, because we aren't successful until you are.
            </p>

            <button
              className="mac-btn mac-btn-lg"
              style={{ marginTop: 36 }}
              onClick={onContact}
              data-testid="final-cta-btn"
            >
              Contact Us <ArrowRight size={16} strokeWidth={2.5} />
            </button>

            <p
              data-testid="final-cta-microtext"
              style={{
                marginTop: 22,
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                fontSize: 11,
                letterSpacing: "0.2em",
                textTransform: "uppercase",
                color: "rgba(255,255,255,0.45)",
              }}
            >
              FOUNDER-LED · FOR PREMIUM &amp; LUXURY BRANDS AND RETAILERS
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
